<script>
import 'shared/assets/styles/talkvia-loading.css';
import LoadingMessages from './LoadingMessages.vue';
export default {
  components: { LoadingMessages },
  props: {
    showMessage: { type: Boolean, default: true },
    size: {
      type: String,
      default: 'small',
    },
    colorScheme: {
      type: String,
      default: '',
    },
  },
  computed: {
    loadingLabel() {
      return 'Carregando';
    },
    colorSchemeClasses() {
      if (this.colorScheme === 'primary') {
        return '!text-n-brand';
      }

      if (this.colorScheme === 'warning') {
        return '!text-n-amber-6';
      }

      if (this.colorScheme === 'success') {
        return '!text-n-teal-9';
      }

      return this.colorScheme;
    },
  },
};
</script>

<template>
  <span
    class="inline-flex flex-col items-center justify-center gap-1 align-middle"
    role="status"
    :aria-label="loadingLabel"
  >
    <span
      class="spinner i-hugeicons-loading-03"
      :class="`${size} ${colorSchemeClasses}`"
      aria-hidden="true"
    />
    <LoadingMessages v-if="showMessage" class="text-n-slate-11" />
  </span>
</template>

<style scoped lang="scss">
.spinner {
  @apply inline-block w-6 h-6 align-middle text-n-slate-10;

  &.message {
    @apply mx-auto my-0 mt-3;
  }

  &.small {
    @apply w-4 h-4;
  }

  &.tiny {
    @apply w-2.5 h-2.5;
  }
}
</style>
